import { createMutation } from '@amzn/gsce-shared-react-lib';
import {
  DeleteMediaCommand,
  type DeleteMediaCommandInput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import { withRetry } from 'src/utils/retryUtils';

/**
 * Mutation hook for deleting an uploaded media object (DELETE /media/{id}).
 * Retried: deleting the same media twice is harmless.
 */
export const useDeleteMediaMutation = createMutation((input: DeleteMediaCommandInput) =>
  withRetry(() => apiHeliosClient.send(new DeleteMediaCommand(input))),
);
